import Vue from 'vue'
import Router from 'vue-router'
import {wxLogin,getLogout,getHref} from '@/utils/util'
import { routers,menu1,menu2} from './router';
// import { set } from 'shelljs';

Vue.use(Router)
const router =  new Router({
  routes: routers.router
})

let state;
let menu=[];//路由列表
// let filerRoute=[];
let userInfo=localStorage.getItem("guanai_userInfo");
let isLogin= !userInfo ? false : true;
// console.log(isLogin,"登陆状态**********")
if(isLogin){
  userInfo=JSON.parse(userInfo) ;
  state=userInfo.user_type;
  addRou();
}
// else{
//   // 暂时为用户注销必须授权登录pjh 2020.10.20打开必须授权登录pjh
//   router.addRoutes(menu2);
// }
function addRou(){
  if(state){   //登陆后才会有角色state这个值
    if(state=="1"){
      menu=menu1;
    }else{
      menu=menu2
    }
    router.addRoutes(menu);
  }
}

// 全局路由守卫
router.beforeEach((to, from, next) => {
  
  // to: Route: 即将要进入的目标 路由对象
  // from: Route: 当前导航正要离开的路由
  // next: Function: 一定要调用该方法来 resolve 这个钩子。执行效果依赖 next 方法的调用参数。
  let userInfoNow=localStorage.getItem("guanai_userInfo");
  let isLoginNow=!userInfoNow ? false : true; // 是否登录
  // 没有登陆的情况下
  if(!isLoginNow){
    // console.log("没有登陆");
     let arrList=["login","transfer","phone","agentInfo","agentMy","myInfo"];
    //必须授权登录功能 pjh 
    // let arrList=["index","productList","productDetails","login","transfer","phone","agentInfo","agentMy","myInfo"];//不需要登陆验证的列表

    if(arrList.indexOf(to.name)==-1){ 
      if(getLogout()){
          router.push({ name: 'login' });
      }else{
        let href=window.location.origin+window.location.pathname+"#"+to.fullPath; 
        // console.log("未登录，且找不到路由",href);
        wxLogin(href); 
      }
    }

  }else{
    //  登陆的情况下
    if(from.name=="transfer" || from.name=="login"){ //这两个页面登陆后，都刷新一次，为了加载路由
      setTimeout(()=>{
          window.location.reload();
      },20)
    }else if(to.name==="login"){  //transfer,phone,agentInfo登陆后都跳转到login
      let href=getHref();
      if(!href){
        router.push({ path: '/' }); //直接跳到根路径，之前带的
      }else{
        console.log("跳转到href",href);
        setTimeout(()=>{
          window.location.href=href;
        },10)
      }
    }else if(!to.name){   //登陆状态下找不到路由跳转到首页
      console.log("跳转到首页");
      router.push({ path: '/' });
    }
  }
  if (to.meta.title) {
      document.title=to.meta.title  
  }
  next();
});
export default router;


// WEBPACK FOOTER //
// ./src/router/index.js